var render = function render(){var _vm=this,_c=_vm._self._c;return _c('empty',{staticStyle:{"height":"100vh"}},[_c('loading',{attrs:{"slot":"description","size":"24px"},slot:"description"},[_vm._v("信息处理中...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }